<template>
  <div class="main-app">
    <Swiper :swiperImgs="swiperImgs" />
    <div class="container">
      <div class="breadcrumb-com">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{
            $t("home")
          }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/soft' }">
            {{ $t("upgrade") }}
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            {{
              newsDetailData !== undefined
                ? newsDetailData.name || newsDetailData.title
                : ""
            }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content">
        <div class="info-box">
          <div class="title">
            {{
              newsDetailData !== undefined
                ? newsDetailData.name || newsDetailData.title
                : ""
            }}
          </div>
          <div
            class="details-body"
            v-html="
              newsDetailData !== undefined
                ? newsDetailData.content || newsDetailData.updatecontent
                : ''
            "
          ></div>
        </div>
        <div class="info-footer">
          <a
            class="download-box"
            href="javascript:;"
            @click="onDownloadPath"
            v-if="downloadPath !== ''"
            >{{ $t("download") }}</a
          >
          <div class="payinfo" v-if="payinfo.length">
            <h2>扫码付款</h2>
            <div class="pay-item" v-for="(v, i) in payinfo" :key="i">
              <div class="pay">
                <img :src="v.pay" alt="" />
              </div>
              <div class="text">{{ v.type }}</div>
            </div>
          </div>
          <a href="javascript:;" @click="onSoftorderCreate" v-else>{{
            $t("upgradeImmediately")
          }}</a>
        </div>
        <div class="more">
          <div class="more-icon">
            <img src="~@a/img/time.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";
import { mapMutations,mapState } from "vuex";
import LStore from "store";
import { timeFormatDate, timeFormatYear, timeFormatMD } from "@/utils";
import Swiper from "@c/Swiper";

export default {
  filters: {
    timeFormatDate,
    timeFormatYear,
    timeFormatMD
  },
  data() {
    return {
      src: require("@a/img/banner-soft.png"),
      newsDetailData: undefined,
      payinfo: [],
      downloadPath: "",
      timeout: null,
      swiperImgs: []
    };
  },
  components: {
    Swiper
  },
  computed: {
    ...mapState(["anselmUserInfo", "isLogin"])
  },
  created() {
    this.topingAll();
    this.productCat();
    this.softDetail({
      id: this.$route.query.id
    });
  },
  methods: {
    ...mapMutations(["PRODUCT_DATA"]),
    productCat(params) {
      API.productCat(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.PRODUCT_DATA(res.data);
          LStore.set("productData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    topingAll(params) {
      API.topingAll(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(
            this,
            "swiperImgs",
            res.data.filter(v => Number(v.typelist) === 4)
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    softDetail(params) {
      API.softDetail(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          this.$set(this, "newsDetailData", res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    softorderCreate(params) {
      API.softorderCreate(params).then(res => {
        if (/^(1)$/.test(res.code)) {
          let orderno = "";
          if (res.msg.payinfo !== undefined) {
            this.$set(this, "payinfo", res.msg.payinfo);
            orderno = res.msg.orderno;
          }
          if (res.data !== null && res.data.payinfo !== undefined) {
            this.$set(this, "payinfo", res.data.payinfo);
            orderno = res.data.orderno;
          }
          // this.softorderOrderpay({
          //   type: "wx",
          //   token: this.anselmUserInfo.token,
          //   userid: this.anselmUserInfo.user_id,
          //   orderno: orderno
          // });
          this.handleSoftorderCheckOrder({
            token: this.anselmUserInfo.token,
            userid: this.anselmUserInfo.user_id,
            orderno: orderno
          });
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    softorderOrderpay(params) {
      API.softorderOrderpay(params).then(res => {
        if (/^(1|8888)$/.test(res.code)) {
          this.$set(this, "downloadPath", res.data.downloadPath);

          this.handleSoftorderCheckOrder(params);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    softorderCheckOrder(params) {
      API.softorderCheckOrder(params).then(res => {
        if (/^(1|8888)$/.test(res.code)) {
          this.$set(this, "downloadPath", res.data.downloadPath);
          clearInterval(this.timeout);
        } else {
          // this.$message.error(res.msg);
        }
      });
    },
    handleSoftorderCheckOrder(params) {
      clearInterval(this.timeout);
      this.timeout = setInterval(() => {
        this.softorderCheckOrder(params);
      }, 3000);
    },
    onDownloadPath() {
      window.open(this.downloadPath);
    },
    onSoftorderCreate() {
      if (this.isLogin) {
        this.$router.push({
          path: "user",
          query: {
            type: "number"
          }
        });
      } else {
        this.$router.push({
          path: "login"
        });
      }

      // if (this.anselmUserInfo !== null) {
      //   this.softorderCreate({
      //     token: this.anselmUserInfo.token,
      //     userid: this.anselmUserInfo.user_id,
      //     sn: this.newsDetailData.sn
      //   });
      // } else {
      //   this.$message({
      //     message: "请登录！",
      //     type: "success",
      //     duration: 1000,
      //     onClose: () => {
      //       this.$router.push({
      //         path: "login"
      //       });
      //     }
      //   });
      // }
    }
  }
};
</script>

<style lang="less" scoped>
.breadcrumb-com {
  display: flex;
  height: 40px;
  align-items: center;
  border-bottom: 1px solid var(--color-line);
}

.content {
  color: var(--color-light-black);
  font-size: 16px;
  line-height: initial;

  .title {
    text-align: center;
    font-size: 28px;
    padding: 40px 10px;
    font-weight: bold;
  }

  p {
    line-height: 40px;
  }

  .more {
    display: flex;
    height: 100px;
    align-items: center;
    justify-content: center;

    .more-icon {
      width: 20px;
    }
  }

  .info-footer {
    margin: 40px 0;

    .payinfo {
      margin-top: 40px;
      h2 {
        font-weight: bold;
      }
      .pay-item {
        display: inline-block;
        text-align: center;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .breadcrumb-com {
    padding: 0 10px;
  }
}
</style>
